<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Kód' | translate">
      {{ entity.code }}
    </td>
    <td :data-th="'Párovat vše' | translate">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"  v-if="entity.allow_pair_devices_from_other_brands_when_static_brand_configured"/>
    </td>
    <td :data-th="'Počet operátorů' | translate">
            <span class="dotted" @click.stop="$refs.operatorsmodalref.showModal(true)" v-if="entity.operators.length > 0">
            {{ entity.operators.length }}
          <modal ref="operatorsmodalref">
            <div slot="title"><translate>Operátoři</translate> ({{entity.operators.length}})</div>
            <div slot="body">
              <ul>
                <li v-for="(item, index) in entity.operators" :key="'channels-'+index">{{item.name}}</li>
              </ul>
            </div>
          </modal>
      </span>
      <span v-else>0</span>
    </td>
    <td :data-th="'Počet domén' | translate">
       <span class="dotted" @click.stop="$refs.domainsmodalref.showModal(true)" v-if="entity.domains.length > 0">
            {{ entity.domains.length }}
          <modal ref="domainsmodalref">
            <div slot="title"><translate>Domény</translate> ({{entity.domains.length}})</div>
            <div slot="body">
              <table class="help_table">
                <thead>
                  <tr>
                    <th v-translate>Doména</th>
                    <th v-translate>CSS Kód</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in entity.domains">
                    <tr :key="index">
                      <td class="nowrap">{{ item.domain }}</td>
                      <td class="nowrap">{{ item.css_code }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </modal>
      </span>
      <span v-else>0</span>
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteBrand">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "BrandRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'brands',
      detailPageRouteName: 'brandDetail',
    }
  },
  methods: {
    emitDeleteBrand() {
      this.$emit('deleteBrand', String(this.entity.id))
    },
  },
  computed: {
    operatorsList() {
      return this.entity.operators.map((operator) => operator.name).join(", ");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/BrandRow.vue